import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { IMyDrpOptions, IMyDateRangeModel } from 'mydaterangepicker';

@Component({
  selector: 'app-custom-datepicker',
  templateUrl: './custom-datepicker.component.html',
  styleUrls: ['./custom-datepicker.component.scss'],
})
export class CustomDatepickerComponent implements OnInit {
  now = new Date();
  initDate = new Date(new Date().setDate(new Date().getDate() - 3));
  endDate = new Date(new Date().setDate(new Date().getDate() - 1));
  // initDummy = new Date(2021, new Date().getMonth(), 1);
  // endDummy = new Date(2021, new Date().getMonth(), 3);
  // initDate = this.initDummy;
  // endDate = this.endDummy;

  myDateRangePickerOptions: IMyDrpOptions = {
    height: '32px',
    width: '232px',
    selectorWidth: '232px',
    selectorHeight: '262px',
    selectionTxtFontSize: '12px',
    dateFormat: 'dd.mm.yyyy',
    showClearBtn: false,
    showApplyBtn: false,
    editableDateRangeField: false,
    openSelectorOnInputClick: true,
    showSelectDateText: false,
    sunHighlight: false,
    showClearDateRangeBtn: false,
    componentDisabled: false,
    dayLabels: {
      su: 'Do',
      mo: 'Lu',
      tu: 'Ma',
      we: 'Mi',
      th: 'Ju',
      fr: 'Vi',
      sa: 'Sa',
    },
    monthLabels: {
      1: 'Enero',
      2: 'Febrero',
      3: 'Marzo',
      4: 'Abril',
      5: 'Mayo',
      6: 'Junio',
      7: 'Julio',
      8: 'Agosto',
      9: 'Septiembre',
      10: 'Octubre',
      11: 'Noviembre',
      12: 'Diciembre',
    },
    // disableUntil: [],
    // disableSince: {
    //   year: this.now.getFullYear(),
    //   month: this.now.getMonth() + 1,
    //   day: this.now.getDate()
    // },
    disableDateRanges: [
      {
        beginDate: {
          year: this.now.getFullYear(),
          month: this.now.getMonth() + 1,
          day: this.now.getDate(),
        },
        endDate: {
          year: 2060,
          month: 11,
          day: 20,
        },
      },
    ],
    // disableDates: [],
  };

  // For example initialize to specific date (09.10.2018 - 19.10.2018). It is also possible
  // to set initial date range value using the selDateRange attribute.
  public model: any = {
    beginDate: {
      year: this.initDate.getFullYear(),
      month: this.initDate.getMonth() + 1,
      day: this.initDate.getDate(),
    },
    endDate: {
      year: this.endDate.getFullYear(),
      month: this.endDate.getMonth() + 1,
      day: this.endDate.getDate(),
    },
  };

  @Output() datesEvent = new EventEmitter<IMyDateRangeModel>();

  constructor() {}

  onDateRangeChanged(event: IMyDateRangeModel) {
    this.datesEvent.emit(event);
  }

  ngOnInit() {
    this.datesEvent.emit(this.model);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/custom-datepicker/custom-datepicker.component.ts